import { configureStore } from '@reduxjs/toolkit';

import tableDataReducer from './reducers/tableSlice';
import viewReducer from './reducers/viewSlice';
import pageReducer from './reducers/pageSlice';
import uiReducer from './reducers/uiStateSlice';
import dataCollectionReducer from './reducers/dataCollectionSlice';
import labellerAssignmentReducer from './reducers/labellerSlice';
import addPatientFormReducer from './reducers/form/addPatientsSlice';
import addSequencesToPatientFormReducer from './reducers/form/addSequencesToPatientSlice';

// Transitional reducers
import dataCollectionsReducer from './reducers/viewData/dataCollections';
import patientsReducer from './reducers/viewData/patients';
import rawSequencesReducer from './reducers/viewData/rawSequences';
import sequenceIntervalsReducer from './reducers/viewData/sequenceIntervals';
import labelsReducer from './reducers/viewData/labels';

import unassignedReducer, {
  tableSlice as unassignedTableSlice,
} from './reducers/supervisorDashboard/unassigned';
import { tableSlice as inprogressTableSlice } from './reducers/supervisorDashboard/inprogress';
import { tableSlice as actionRequiredTableSlice } from './reducers/supervisorDashboard/actionRequired';
import { tableSlice as finishedTableSlice } from './reducers/supervisorDashboard/finished';
import { tableSlice as labellersTableSlice } from './reducers/supervisorDashboard/labellers';
import { tableSlice as labellerDashboardTodoTableSlice } from './reducers/labellerDashboard/todo';
import { tableSlice as labellerDashboardPendingTableSlice } from './reducers/labellerDashboard/pending';
import { tableSlice as labellerDashboardFinishedTableSlice } from './reducers/labellerDashboard/finished';
import { tableSlice as dataCurationDashboardLabellingCandidatesTableSlice } from './reducers/dataCurationDashboard/labellingCandidates';
import { tableSlice as dataCurationDashboardStagedForSplittingTableSlice } from './reducers/dataCurationDashboard/stagedForSplitting';
import { tableSlice as dataCurationDashboardPendingTableSlice } from './reducers/dataCurationDashboard/pending';
import { tableSlice as viewDataDataCollectionsTableSlice } from './reducers/viewData/dataCollections';
import { tableSlice as viewDataLabelsTableSlice } from './reducers/viewData/labels';
import { tableSlice as viewDataPatientsTableSlice } from './reducers/viewData/patients';
import { tableSlice as viewDataRawSequencesTableSlice } from './reducers/viewData/rawSequences';
import { tableSlice as viewDataSequenceIntervalsTableSlice } from './reducers/viewData/sequenceIntervals';
import { tableSlice as automatedJobsAutolabelTableSlice } from './reducers/automatedJobs/autolabel';
import { tableSlice as automatedJobsDicomConversionTableSlice } from './reducers/automatedJobs/dicom_conversion';
import { tableSlice as automatedJobsPreprocessingTableSlice } from './reducers/automatedJobs/preprocessing';
import { tableSlice as automatedJobsSequenceSplittingTableSlice } from './reducers/automatedJobs/sequence_splitting';
import { tableSlice as automatedJobsLabelCheckTableSlice } from './reducers/automatedJobs/label_check';
import { tableSlice as notificationsSeenTableSlice } from './reducers/notifications/seen';
import { tableSlice as notificationsUnseenTableSlice } from './reducers/notifications/unseen';

import { tabSlice as viewDataTabSlice } from './reducers/viewData/tabs';
import { tabSlice as supervisorDashboardTabSlice } from './reducers/supervisorDashboard/tabs';
import { tabSlice as labellerDashboardTabSlice } from './reducers/labellerDashboard/tabs';
import { tabSlice as dataCurationDashboardTabSlice } from './reducers/dataCurationDashboard/tabs';
import { tabSlice as automatedJobsTabSlice } from './reducers/automatedJobs/tabs';
import { tabSlice as notificationTabSlice } from './reducers/notifications/tabs';

function combineSlices() {
  const slices = [
    unassignedTableSlice,
    inprogressTableSlice,
    actionRequiredTableSlice,
    finishedTableSlice,
    labellersTableSlice,
    labellerDashboardTodoTableSlice,
    labellerDashboardPendingTableSlice,
    labellerDashboardFinishedTableSlice,
    dataCurationDashboardLabellingCandidatesTableSlice,
    dataCurationDashboardStagedForSplittingTableSlice,
    dataCurationDashboardPendingTableSlice,
    viewDataDataCollectionsTableSlice,
    viewDataLabelsTableSlice,
    viewDataPatientsTableSlice,
    viewDataRawSequencesTableSlice,
    viewDataSequenceIntervalsTableSlice,
    viewDataTabSlice,
    supervisorDashboardTabSlice,
    labellerDashboardTabSlice,
    dataCurationDashboardTabSlice,
    automatedJobsTabSlice,
    notificationTabSlice,
    automatedJobsAutolabelTableSlice,
    automatedJobsDicomConversionTableSlice,
    automatedJobsPreprocessingTableSlice,
    automatedJobsSequenceSplittingTableSlice,
    automatedJobsLabelCheckTableSlice,
    notificationsSeenTableSlice,
    notificationsUnseenTableSlice,
  ];
  let reducer = {};
  slices.forEach((slice) => (reducer[slice.name] = slice.reducer));
  return reducer;
}

export default configureStore({
  reducer: {
    tableData: tableDataReducer,
    view: viewReducer,
    page: pageReducer,
    ui: uiReducer,
    dataCollection: dataCollectionReducer,
    labellerAssignment: labellerAssignmentReducer,
    addPatientForm: addPatientFormReducer,
    addSequencesToPatientForm: addSequencesToPatientFormReducer,
    // Transitional reducers
    // View Data
    dataCollections: dataCollectionsReducer,
    patients: patientsReducer,
    rawSequences: rawSequencesReducer,
    sequenceIntervals: sequenceIntervalsReducer,
    labelDVTs: labelsReducer,
    // supervisorDashboard
    unassigned: unassignedReducer,
    ...combineSlices(),
  },
});
